import moduleLoader from "flow/wrappers/moduleLoader";
import MyFlow from "flow/MyFlow";

function getViewModel(myFlow: MyFlow, viewModelId: string) {
    return new Promise((resolve, reject) => {
        moduleLoader
            .requireSingleAsync(viewModelId)
            .then(resolve)
            .catch((err: any) => {
                if (err.requireModules) {
                    // If we failed on a dependency, log it
                    err.requireModules.forEach((failedModuleId: string) => {
                        myFlow.error("Failed to load " + failedModuleId);
                    });
                }

                reject(err);
            });
    });
}

export default {
    getViewModel
};
